import { render } from "./PosProduct.vue?vue&type=template&id=543312a8&ts=true"
import script from "./PosProduct.vue?vue&type=script&lang=ts"
export * from "./PosProduct.vue?vue&type=script&lang=ts"

import "./PosProduct.vue?vue&type=style&index=0&id=543312a8&lang=scss"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__